import React, { useState, useEffect } from 'react';
import './WorkPlatforms.css';

// Import images from src/slider folder
import work1 from '../slider/work1.png';
import work2 from '../slider/Work2.png';
import work3 from '../slider/Work3.png';
import work4 from '../slider/Work4.png';
import work5 from '../slider/Work5.png';

const WorkPlatforms = () => {
  const [currentSlide, setCurrentSlide] = useState(0);
  
  const images = [
    { src: work1, alt: 'Work Platform 1' },
    { src: work2, alt: 'Work Platform 2' },
    { src: work3, alt: 'Work Platform 3' },
    { src: work4, alt: 'Work Platform 4' },
    { src: work5, alt: 'Work Platform 5' }
  ];

  const nextSlide = () => {
    setCurrentSlide((prev) => (prev + 1) % (images.length - 2));
  };

  const prevSlide = () => {
    setCurrentSlide((prev) => (prev - 1 + (images.length - 2)) % (images.length - 2));
  };

  const goToSlide = (index) => {
    setCurrentSlide(index);
  };

  // Auto-advance slides every 4 seconds
  useEffect(() => {
    const interval = setInterval(nextSlide, 4000);
    return () => clearInterval(interval);
  }, []);

  return (
    <section className="work-platforms" id="work-platforms">
      <div className="container">
        <h2 className="section-title">WORK PLATFORMS</h2>
        <div className="slider-container">
          <div className="slider-wrapper">
            <button className="slider-btn prev-btn" onClick={prevSlide}>
              &#8249;
            </button>
            
            <div className="slider-track">
              <div 
                className="slides-container"
                style={{ transform: `translateX(-${currentSlide * 33.333}%)` }}
              >
                {images.map((image, index) => (
                  <div key={index} className="slide">
                    <div className="slide-content">
                      <img 
                        src={image.src} 
                        alt={image.alt}
                        className="slider-image"
                      />
                    </div>
                  </div>
                ))}
              </div>
            </div>
            
            <button className="slider-btn next-btn" onClick={nextSlide}>
              &#8250;
            </button>
          </div>
        </div>
      </div>
    </section>
  );
};

export default WorkPlatforms;